/* @ngInject */
const commandeCtrl = (
  $scope,
  $$commande,
) => {
  $scope.$$commande = $$commande
}

export default commandeCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/commande/commande.controller.js